module.exports = __webpack_public_path__ + "static/media/icn_self_itr.6afc5fdf.svg";